import script from "./ExamPaper1.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamPaper1.vue?vue&type=script&setup=true&lang=js"

import "./ExamPaper1.vue?vue&type=style&index=0&id=2945842e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2945842e"]])

export default __exports__